module.exports = require("@material-ui/icons/WifiLock");